import { render, staticRenderFns } from "./DepartureInheritanced.vue?vue&type=template&id=4bbbd298&scoped=true&"
import script from "./DepartureInheritanced.vue?vue&type=script&lang=ts&"
export * from "./DepartureInheritanced.vue?vue&type=script&lang=ts&"
import style0 from "./DepartureInheritanced.vue?vue&type=style&index=0&id=4bbbd298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbd298",
  null
  
)

export default component.exports